import { ViewModel } from '../view-model';
import { CONFIG } from '../../core/config';

export class GuidList implements ViewModel {
  readonly friendlyTypeNameSingular = 'Guild List Collection';
  readonly apiRoute: string = CONFIG.apiRoutes.guildList;

  guids: string[] = [];

  json() {
    return this;
  }

  loadFromJson(data) {
    this.guids = data.guids;
  }
}
